import React from 'react';
import { Search, Filter, X } from 'lucide-react';
import { useUser } from '../contexts/UserContext';

const UserFilters: React.FC = () => {
  const { state, actions } = useUser();
  const { filters } = state;

  const statusOptions = [
    { value: 'all', label: 'Todos os Status' },
    { value: 'active', label: 'Apenas Ativos' },
    { value: 'inactive', label: 'Apenas Inativos' },
  ];

  const roleOptions = [
    { value: 'all', label: 'Todas as Roles' },
    { value: 'admin', label: 'Administrador' },
    { value: 'gestor', label: 'Gestor' },
    { value: 'emissor', label: 'Emissor' },
    { value: 'reader', label: 'Leitor' },
  ];

  const hasActiveFilters = 
    filters.status !== 'all' ||
    filters.role !== 'all' ||
    filters.search !== '';

  return (
    <div className="card" style={{ marginBottom: '20px' }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        marginBottom: '16px' 
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Filter size={18} />
          <h4 style={{ margin: 0 }}>Filtros</h4>
          {hasActiveFilters && (
            <span style={{
              background: 'var(--color-blue)',
              color: 'white',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: 'var(--font-size-12)',
              fontWeight: 500,
            }}>
              Ativo
            </span>
          )}
        </div>
        
        {hasActiveFilters && (
          <button
            onClick={actions.resetFilters}
            className="btn btn-secondary"
            style={{ padding: '6px 12px' }}
            title="Limpar filtros"
          >
            <X size={14} />
            Limpar
          </button>
        )}
      </div>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
        gap: '16px',
        marginBottom: '16px' 
      }}>
        <div className="form-group">
          <label className="form-label">Status</label>
          <select
            value={filters.status}
            onChange={(e) => actions.setFilters({ status: e.target.value as any })}
            className="form-select"
          >
            {statusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Role</label>
          <select
            value={filters.role}
            onChange={(e) => actions.setFilters({ role: e.target.value as any })}
            className="form-select"
          >
            {roleOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-group" style={{ margin: 0 }}>
        <label className="form-label">Busca</label>
        <div style={{ position: 'relative' }}>
          <Search 
            size={16} 
            style={{ 
              position: 'absolute', 
              left: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)',
              color: 'var(--color-darkgray)'
            }} 
          />
          <input
            type="text"
            value={filters.search}
            onChange={(e) => actions.setFilters({ search: e.target.value })}
            className="form-input"
            placeholder="Buscar por nome, email, criador..."
            style={{ paddingLeft: '40px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default UserFilters;